
jQuery(function() {
    
	var EMAIL_CHECK = 'cookie-email';
    
	$email_check = $.cookie(EMAIL_CHECK);

    

    if($('#form_email').length){
        $('#galeries').hide();
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            // ta fonction
            $('#form_email').hide();
            $('#galeries').show();
            $.cookie(EMAIL_CHECK, 'done', { path: '/', expires: 6 });
        }, false );
    }

    //
	if ($email_check != 'done') {
        $('#galeries').hide();
        // console.log('cookie not set');
	}else{
        $('#form_email').hide();
        $('#galeries').show();
        // console.log('cookie is set');
    }

    // COOKIE NOTICE
    // var COOKIE_NOTICE = 'cookie-notice';

	
	// $gonotice = $.cookie(COOKIE_NOTICE);
	// if ($gonotice == null) {
    //     $('body').append('<div class="cookieConsentContainer" id="cookieConsentContainer"><div class="cookieTitle"><a>Cookies</a></div><div class="cookieDesc"><p>Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre site web. Si vous continuez à utiliser ce site, nous supposerons que vous en êtes satisfait. <a href="/politique-vie-privee/">Politique de vie privée</a><a class="closecookie">J\'ai compris</a></p></div>');
    //     $('#cookieConsentContainer').fadeIn();
	// }
	// $('#cookieConsentContainer .closecookie').on('click',function(){
	// 	$.cookie(COOKIE_NOTICE, 'done', { path: '/', expires: 6 });
	// 	$('#cookieConsentContainer').fadeOut();
	// });
	
}); 